<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" :title="title" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<b-tabs v-model="selectedTabIndex">
			<b-tab title="Podatki nadomestnega vozila" class="pt-2" card>
				<CRow>
					<CCol col="2">
						<replacement-vehicle-change-image :replacementVehicle="replacementVehicle"/>
						<div class="ml-3">
							<span class="costum-switch prepend">
								Vinjeta
							</span>
							<span class="costum-switch content">
								<CSwitch
									class="pt-2"
									:disabled="editingDisabled"
									variant="opposite"
									color="primary"
									v-bind="settings.yesNoLabelTxt"
									:checked.sync="replacementVehicle.vignette">
								</CSwitch>
							</span>
						</div>
					</CCol>
					<CCol>
						<CRow class="mt-4">
							<CCol>
								<CInput
									label="VIN"
									:disabled = editingDisabled
									v-model="replacementVehicle.vin"/>
							</CCol>
							<CCol>
								<label>Znamka</label>
								<v-select
									:disabled="editingDisabled"
									v-model="selectedBrand"
									:options="allVehicleBrands"
									label="title"
									@input="change_brandsSelect"
									placeholder="Izberi znamko ...">
									<template slot="no-options">Znamka ne obstaja</template>
									<template slot="option" slot-scope="option">
										<b-row>
											<b-col cols=2 class="p-0 m-0">
												<div v-if="option.logo" :style="imagesTool.vehicleBrandImage(option.logo, 2)"></div>
												<CIcon v-else :style="imagesTool.vehicleBrandIcon(2)" name="cil-car-alt"/>
											</b-col>
											<b-col class="pl-0 pt-2">
												{{ option.title }}
											</b-col>
										</b-row>
									</template> 
									<template slot="selected-option" slot-scope="option">
										<div v-if="option.logo" :style="imagesTool.vehicleBrandImage(option.logo, 1.3)"></div>
										<CIcon v-else :style="imagesTool.vehicleBrandIcon(1.3)" name="cil-car-alt"/>
										<div class="ml-2">{{ option.title }}</div>
									</template>
								</v-select>
							</CCol>
							<CCol>
								<CInput
									label="Naziv"
									:disabled = editingDisabled
									v-model="replacementVehicle.model"/>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<CInput
									label="Registrska"
									:disabled = editingDisabled
									v-model="replacementVehicle.registration_number"/>
							</CCol>
							<CCol v-if="editingDisabled">
								<CInput
									:disabled = editingDisabled
									label="Datum let. servisa"
									:value="getDateInputValue(replacementVehicle.annual_service_date)"/>
							</CCol>
							<CCol v-else>
								<v-date-picker
									locale="sl-SI"
									v-model="replacementVehicle.annual_service_date"
									:model-config=" {
										type: 'string',
									}"
									timezone='utc'>
									<template v-slot="{ inputValue, inputEvents }">
										<CInput
											label="Datum let. servisa"
											:value="inputValue"
											v-on="inputEvents"/>
									</template>
								</v-date-picker>
							</CCol>
							<CCol v-if="editingDisabled">
								<CInput
									:disabled = editingDisabled
									label="Datum registracije"
									:value="getDateInputValue(replacementVehicle.registration_date)"/>
							</CCol>
							<CCol v-else>
								<v-date-picker
									locale="sl-SI"
									v-model="replacementVehicle.registration_date"
									:model-config=" {
										type: 'string',
									}"
									timezone='utc'>
									<template v-slot="{ inputValue, inputEvents }">
										<CInput
											label="Datum registracije"
											:value="inputValue"
											v-on="inputEvents"/>
									</template>
								</v-date-picker>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<label>Gume</label>
								<v-select
									:disabled="editingDisabled"
									v-model="replacementVehicle.workflow_status"
									:options="settings.replacementVehicleTiresOptions"
									placeholder="Izberi Zimske/Letne">
								</v-select>
							</CCol>
							<CCol>
								<label>Oddelek</label>
								<v-select
									:disabled="editingDisabled"
									v-model="replacementVehicle.department"
									:options="settings.replacementVehicleDepartmentOptions"
									placeholder="Izberi">
								</v-select>
							</CCol>
							<CCol>
								<CInput
									label="Zadolžena oseba"
									:disabled = editingDisabled
									v-model="replacementVehicle.responsible_person"/>
							</CCol>
						</CRow>
					</CCol>
				</CRow>
			</b-tab>
			<b-tab v-if="mode === mode_EDIT2 || mode === mode_DETAILS3" title="Rezervacije">
				<b-card>
					<vue-loading :active.sync="replacementVehicleReservationsTableProps.isLoading" :is-full-page="false"/>
					<div slot="header">
						<b>Seznam rezervacij</b>
						<div class="card-header-actions">
							<CLink title="Osveži tabelo" href="#" class="card-header-action btn-setting" @click.stop="click_replacementVehicleReservationsTableRefresh">
								<CIcon name="cil-loop-circular" class="mb-1"/>
							</CLink>
							<CLink title="Dodaj rezervacijo" href="#" class="card-header-action btn-setting" @click.stop="click_replacementVehicleReservationCreate">
								<CIcon name="cil-plus" class="mb-1"/>
							</CLink>
							<CLink v-if="false" title="Ponastavi filtre" href="#" class="card-header-action btn-setting" @click.stop="click_replacementVehicleReservationsTableResetFilters">
								<CIcon name="cil-x" class="mb-1"/>
							</CLink>
						</div>
					</div>
					<b-table
						ref="replacementVehicleReservationsTable"
						responsive="sm"
						striped
						show-empty
						hover
						selectable
						:empty-text="replacementVehicleReservationsTableProps.empty_text"
						:empty-filtered-text="replacementVehicleReservationsTableProps.empty_filtered_text"
						:fields="replacementVehicleReservationsTableProps.fields"
						:current-page="replacementVehicleReservationsTableProps.currentPage"
						:per-page="replacementVehicleReservationsTableProps.itemsPerPage"
						:items="replacementVehicleReservationsTable_items"
						:sort-by.sync="replacementVehicleReservationsTableProps.sortBy"
						:sort-desc.sync="replacementVehicleReservationsTableProps.sortDesc"
						@row-clicked="rowClicked_replacementVehicleReservationsTable">
						<template v-slot:cell(created_at)="data">
							{{ data.item.created_at | viewDateTime }}
						</template>
						<template v-slot:cell(sp_order_number)="data">
							<div v-if="data.item.sp_order">{{ data.item.sp_order.sp_order_number }}</div>
							<div v-else>/</div>
						</template>
						<template v-slot:cell(client)="data">
							<div v-if="data.item.client">{{ mixinGetClientFullName(data.item.client) }}</div>
							<div v-else>/</div>
						</template>
						<template v-slot:cell(starts_on)="data">
							{{ data.item.starts_on | viewDate }}
						</template>
						<template v-slot:cell(ends_on)="data">
							{{ data.item.ends_on | viewDate }}
						</template>
						<template v-slot:cell(contract_valid_from)="data">
							<div v-if="data.item.contract_valid_from">
								{{ data.item.contract_valid_from | viewDate }}
							</div>
						</template>
						<template v-slot:cell(contract_valid_to)="data">
							<div v-if="data.item.contract_valid_to">
								{{ data.item.contract_valid_to | viewDate }}
							</div>
						</template>
						<template v-slot:cell(actions)="data">
							<b-button title="Uredi rezervacijo" variant="primary" @click.stop="click_replacementVehicleReservationEdit(data.item)" size="sm" class="mr-2">
								<CIcon name="cil-pencil"/>
							</b-button>
							<b-button :disabled="data.item.contract_printed_at ? true : false" :title="data.item.contract_printed_at ? 'Vozilo je že bilo izdano' : 'Izbriši rezervacijo'" variant="danger" @click.stop="click_replacementVehicleReservationDelete(data.item)" size="sm" class="mr-2">
								<CIcon name="cil-trash"/>
							</b-button>
						</template>	
						<template slot="row-details" slot-scope="data">
							details
						</template>
					</b-table>
					<nav>
						<b-row>
							<b-col>
								<b-pagination :total-rows="replacementVehicleReservationsTableProps.totalItems" :per-page="replacementVehicleReservationsTableProps.itemsPerPage" v-model="replacementVehicleReservationsTableProps.currentPage" prev-text="Prejšnja" next-text="Naslednja" hide-goto-end-buttons />
							</b-col>
							
							<b-col cols=2>
								<a class="page-link rows_total float-right">Št. vrstic: {{ replacementVehicleReservationsTableProps.totalItems }}</a>
							</b-col>
							<b-col cols=1>
								<b-form-select v-model="replacementVehicleReservationsTableProps.itemsPerPage" :options="replacementVehicleReservationsTableProps.options_numRowsOnPage"></b-form-select>
							</b-col>
						</b-row>
					</nav>
				</b-card>
			</b-tab>
		</b-tabs>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="okButton.disabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
		<replacement-vehicle-reservation-create-edit-modal ref="replacementVehicleReservationCreateEditModal" @emit_replacementVehicleReservationCreatedOrEdited="emit_replacementVehicleReservationCreatedOrEdited"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
import PermissionCheck from '@/tools/permission-check';
import imagesTool from '@/tools/images';
import { REPLACEMENT_VEHICLE_CREATE } from '../../store/actions/replacementVehicles';
import { REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED, REPLACEMENT_VEHICLE_RESERVATION_DELETE } from '../../store/actions/replacementVehicleReservations';
import { VEHICLE_BRANDS_LIST_ALL } from "@/store/actions/vehicleBrands";
import ReplacementVehicleReservationCreateEdit from '@/views/modals/ReplacementVehicleReservationCreateEdit';
import ReplacementVehicleChangeImage from '@/views/components/ReplacementVehicleChangeImage';

export default {
	name: 'replacement-vehicle-create-edit-modal',
	components: {
		'replacement-vehicle-reservation-create-edit-modal': ReplacementVehicleReservationCreateEdit,
		'replacement-vehicle-change-image': ReplacementVehicleChangeImage
	},
	props: {
	},
	methods: {
		showModal: function (modalInput) {
			/*
				mode 1 => Create
				mode 2 => Edit
				mode 3 => Details
			*/
			this.mode = modalInput.mode;
			this.initModal(modalInput.replacementVehicle);
		},
		initModal: function (replacementVehicle) {
			if (this.mode === this.mode_CREATE1) {
				this.title = 'Dodajanje nadomestnega vozila';
				this.okButton.label = 'Dodaj';
				let today = new Date();
				today.setUTCHours(0,0,0,0);
				this.replacementVehicle.annual_service_date = today.toISOString();
				this.replacementVehicle.registration_date = today.toISOString();
			} else if (this.mode === this.mode_EDIT2) {
				this.title = 'Urejanje nadomestnega vozila ' + replacementVehicle.vin;
				this.replacementVehicleReservationsTableProps.inputFilter.replacementVehicleId = replacementVehicle.id;
				this.initReplacementVehicle(replacementVehicle);
				this.okButton.label = 'Shrani';
			} else if (this.mode === this.mode_DETAILS3) {
				this.title = 'Nadomestnno vozilo ' + replacementVehicle.vin;
				this.replacementVehicleReservationsTableProps.inputFilter.replacementVehicleId = replacementVehicle.id;
				this.initReplacementVehicle(replacementVehicle);
				this.okButton.label = 'Uredi';
			} else {
				this.mode = this.mode_UNKNOWN0;
				this.title = 'Neznan način';
				this.okButton.label = 'Zapri';
			}
			this.$refs.modal.show();
		},
		initReplacementVehicle: function (replacementVehicle) {
			this.replacementVehicle.id = replacementVehicle.id;
			this.replacementVehicle.vin = replacementVehicle.vin;
			this.replacementVehicle.brand_id = replacementVehicle.brand_id;
			this.selectedBrand = this.allVehicleBrands.find(brand => brand.id === replacementVehicle.brand_id);
			this.replacementVehicle.model = replacementVehicle.model;
			this.replacementVehicle.annual_service_date = replacementVehicle.annual_service_date;
			this.replacementVehicle.registration_date = replacementVehicle.registration_date;
			this.replacementVehicle.responsible_person = replacementVehicle.responsible_person;
			this.replacementVehicle.responsible_person_id = replacementVehicle.responsible_person_id;
			this.replacementVehicle.own_vehicle = replacementVehicle.own_vehicle == 1 ? true : false;
			this.replacementVehicle.workflow_status = this.settings.replacementVehicleTiresOptions.find(season => season.value === replacementVehicle.workflow_status);
			this.replacementVehicle.workflow_status_id = replacementVehicle.workflow_status_id;
			this.replacementVehicle.registration_number = replacementVehicle.registration_number;
			this.replacementVehicle.type_of_use = replacementVehicle.type_of_use;
			this.replacementVehicleReservation.replacementVehicleId = replacementVehicle.id;
			this.replacementVehicle.department = this.settings.replacementVehicleDepartmentOptions.find(department => department.value === replacementVehicle.department); replacementVehicle.department;
			this.replacementVehicle.vignette = !!replacementVehicle.vignette;
			this.replacementVehicle.image = replacementVehicle.image;
			this.replacementVehicle.image_name = replacementVehicle.image_name;
			this.replacementVehicle.issued_but_not_finished_reservation = replacementVehicle.issued_but_not_finished_reservation;
		},
		onOkModal: function () {
			if (this.mode == this.mode_DETAILS3) {
				this.mode = this.mode_EDIT2;
				this.okButton.label = 'Shrani';
			}
			else this.saveReplacementVehicle();
		},
		saveReplacementVehicle: function () {
			this.startProgress();
			this.$store.dispatch(REPLACEMENT_VEHICLE_CREATE, { replacementVehicle: this.replacementVehicle })
				.then((responseData) => {
					this.startProgress();
					this.$emit('emit_replacementVehicleCreatedOrEdited', responseData);
					this.$refs.modal.hide();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						if (this.mode === this.mode_CREATE1) {
							this.showAlert('Napaka pri dodajanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else if (this.mode === this.mode_EDIT2) {
							this.showAlert('Napaka pri urejanju! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						} else {
							this.showAlert('Neznan način modala! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
						}
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Shrani',
				progress: false,
				disabled: false
			};
			this.showAlert();
			this.mode = 0;
			this.resetReplacementVehicleObject();
			this.resetReplacementVehicleReservationsTableProps();
		},
		resetReplacementVehicleObject: function () {
			this.replacementVehicle.id = null;
			this.replacementVehicle.vin = '';
			this.replacementVehicle.brand_id = null;
			this.selectedBrand = null;
			this.replacementVehicle.model = null;
			this.replacementVehicle.annual_service_date = null;
			this.replacementVehicle.registration_date = null;
			this.replacementVehicle.responsible_person = '';
			this.replacementVehicle.responsible_person_id = null;
			this.replacementVehicle.own_vehicle = null;
			this.replacementVehicle.workflow_status = this.settings.replacementVehicleTiresOptions[0];
			this.replacementVehicle.workflow_status_id = null;
			this.replacementVehicle.registration_number = '';
			this.replacementVehicle.type_of_use = '';
			this.replacementVehicle.department = this.settings.replacementVehicleDepartmentOptions[0];
			this.replacementVehicle.vignette = false;
			this.replacementVehicle.image = null;
			this.replacementVehicle.image_name = null;
			this.replacementVehicle.issued_but_not_finished_reservation = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		click_replacementVehicleReservationsTableRefresh: function () {
			this.$refs.replacementVehicleReservationsTable.refresh();
		},
		click_replacementVehicleReservationsTableResetFilters: function () {
			this.replacementVehicleReservationsTableProps.inputFilter.replacementVehicleId = null;
			this.$refs.replacementVehicleReservationsTable.refresh();
		},
		replacementVehicleReservationsTable_items: function (ctx) {
			this.replacementVehicleReservationsTableProps.isLoading = true;
			return this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATIONS_LIST_FILTERED, { ctx: ctx, tableProps: this.replacementVehicleReservationsTableProps })
				.then((responseData) => {
					this.replacementVehicleReservationsTableProps.isLoading = false;
					this.replacementVehicleReservationsTableProps.items = responseData.replacementVehicleReservationsPagination.data;
					this.replacementVehicleReservationsTableProps.totalItems = responseData.replacementVehicleReservationsPagination.total;
					this.replacementVehicleReservationsTableProps.empty_text = 'Ni vnosov';
					return responseData.replacementVehicleReservationsPagination.data;
				})
				.catch(error => {
					this.replacementVehicleReservationsTableProps.isLoading = false;
					this.replacementVehicleReservationsTableProps.items = [];
					this.replacementVehicleReservationsTableProps.totalItems = 0;
					this.replacementVehicleReservationsTableProps.empty_text = 'Napaka pri pridobivanju rezervacij nadomestnega vozila';
					console.log(error);
					return [];
				});
		},
		replacementVehicleReservationsTableTextFilter_change: function (value) {
			if (this.replacementVehicleReservationsTableProps.textFilterTimeout !== null) {
				clearTimeout(this.replacementVehicleReservationsTableProps.textFilterTimeout);
			}
			this.replacementVehicleReservationsTableProps.textFilterTimeout = setTimeout(() => {
				this.$refs.replacementVehicleReservationsTable.refresh();
			}, settings.filterTimeoutLength);
		},
		resetReplacementVehicleReservationsTableProps: function() {
			this.replacementVehicleReservationsTableProps.sortBy = 'created_at';
			this.replacementVehicleReservationsTableProps.sortDesc = true;
			this.replacementVehicleReservationsTableProps.currentPage = 1;
			this.replacementVehicleReservationsTableProps.itemsPerPage = 10;
			this.replacementVehicleReservationsTableProps.totalItems = 0;
			this.replacementVehicleReservationsTableProps.isLoading = false;
			this.replacementVehicleReservationsTableProps.empty_text = '';
			this.replacementVehicleReservationsTableProps.empty_filtered_text = 'Ni zadetkov';
			this.replacementVehicleReservationsTableProps.textFilterTimeout = null;
			this.replacementVehicleReservationsTableProps.errorText = '';
			this.replacementVehicleReservationsTableProps.inputFilter.replacementVehicleId = null;
			this.selectedTabIndex = 0;
		},
		rowClicked_replacementVehicleReservationsTable (row) {
			row._showDetails = !row._showDetails;
		},
		click_replacementVehicleReservationCreate: function () {
			let replacementVehicleReservation = this.replacementVehicleReservation;
			let modalInput = {
				mode: 1, // create mode
				replacementVehicleReservation,
				replacementVehicleVin: this.replacementVehicle.vin,
				issuedButNotFinishedReservation: this.replacementVehicle.issued_but_not_finished_reservation
			}
			this.$refs.replacementVehicleReservationCreateEditModal.showModal(modalInput);
		},
		emit_replacementVehicleReservationCreatedOrEdited: function (data) {
			if (data && data.message == 'edited') this.showAlert('Rezervacija uspešno urejena.', this.ALERT_TYPE_SUCCESS);
			this.$refs.replacementVehicleReservationsTable.refresh();
			this.$emit('emit_replacementVehicleCreatedOrEdited');
		},
		click_replacementVehicleReservationEdit: function (data) {
			let modalInput = {
				mode: 2, // edit mode
				replacementVehicleReservation: data,
				replacementVehicleVin: this.replacementVehicle.vin,
				issuedButNotFinishedReservation: this.replacementVehicle.issued_but_not_finished_reservation
			}
			this.$refs.replacementVehicleReservationCreateEditModal.showModal(modalInput);
		},
		click_replacementVehicleReservationDelete: function (data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati rezervacijo ' + data.id + '?', {
				title: 'Potrdite brisanje rezervacije nadomestnega vozila',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.isLoadingDeleting = true;
					this.$store.dispatch(REPLACEMENT_VEHICLE_RESERVATION_DELETE, { id: data.id })
						.then((responseData) => {
							this.isLoadingDeleting = false;
							this.showAlert('Rezervacija št. ' + data.id + ' uspešno izbrisana.', this.ALERT_TYPE_SUCCESS, 5);
							this.$emit('emit_replacementVehicleCreatedOrEdited');
							this.$refs.replacementVehicleReservationsTable.refresh();
						})
						.catch(error => {
							this.isLoadingDeleting = false;
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri brisanju rezervacije! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka pri brisanju rezervacije! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				}
			}).catch(err => {
				console.error(err);
			})
		},
		change_brandsSelect: function (brand) {
			if (brand) {
				this.replacementVehicle.brand_id = brand.id;
			} else {
				this.replacementVehicle.brand_id = null;
			}
		},
	},
	data: function () {
		return {
			settings,
			imagesTool,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Shrani',
				progress: false,
				disabled: false
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			mode_UNKNOWN0: 0,
			mode_CREATE1: 1,
			mode_EDIT2: 2,
			mode_DETAILS3: 3,
			mode: 0,
			replacementVehicle: {
				id: null,
				vin: '',
				brand_id: null,
				model: null,
				annual_service_date: null,
				registration_date: null,
				responsible_person: '',
				responsible_person_id: null,
				own_vehicle: false,
				workflow_status: settings.replacementVehicleTiresOptions[0],
				workflow_status_id: null,
				registration_number: '',
				type_of_use: '',
				department: settings.replacementVehicleDepartmentOptions[0],
				vignette: false,
				image: null,
				image_name: null,
				issued_but_not_finished_reservation: null,
			},
			replacementVehicleReservationsTableProps: {
				sortBy: 'ends_on',
				sortDesc: true,
				fields: [
					{ key: 'id', label: 'Id', sortable: true, class: '' },
					{ key: 'sp_order_number', label: 'Št. delovnega naloga', sortable: true, class: '' },
					{ key: 'client', label: 'Stranka', sortable: true, class: '' },
					{ key: 'starts_on', label: 'Začetek', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'ends_on', label: 'Konec', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'comment', label: 'Komentar', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'handed_over_by', label: 'Vozilo oddal', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'notes', label: 'Opombe', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'contract_valid_from', label: 'Pogodba veljavna od', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'contract_valid_to', label: 'Pogodba veljavna do', sortable: true, class: 'tdReplacementVehicleReservationsDates' },
					{ key: 'actions', label: '#', sortable: false, class: 'tdReplacementVehicleReservationsActions' }
				],
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				isLoading: false,
				options_numRowsOnPage: [
					{ value: 10, text: '10' },
					{ value: 20, text: '20' },
					{ value: 100, text: '100' },
					{ value: 200, text: '200' }
				],
				empty_text: '',
				empty_filtered_text: 'Ni zadetkov',
				inputFilter: {
					replacementVehicleId: null
				},
				textFilterTimeout: null,
				errorText: ''
			},
			selectedTabIndex: 0,
			permissionCheck: PermissionCheck,
			isOwnVehicleLabelTxt: {
				labelOn: 'Da',
				labelOff: 'Ne'
			},
			replacementVehicleReservation: {
				replacementVehicleId: null
			},
			selectedBrand: null,
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			return 'xl';
		},
		editingDisabled () {
			if (this.mode === this.mode_DETAILS3) {
				return true;
			}
			return false;
		},
		allVehicleBrands: function() {
			if (this.$store.getters.getAllVehicleBrands) {
				return this.$store.getters.getAllVehicleBrands;
			} else {
				this.$store.dispatch(VEHICLE_BRANDS_LIST_ALL)
					.then((responseData) => {
						console.log(responseData);
						return responseData.vehicleBrands;
					})
					.catch(error => {
						console.error(error);
					});
			}
		},
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
</style>
<style>
.tdReplacementVehicleReservationsDates {
	width: 7rem;
	max-width: 7rem;
}
.tdReplacementVehicleReservationsActions {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
}
</style>